import { JobRecurring as APIJobRecurring } from 'api/domain/entities/Job';

export type JobRecurring = APIJobRecurring;
export const JobRecurring = APIJobRecurring;
